<template>
    <layout-empty v-if="(loading && isOnline)" @loaded="onLoaded"/>
    <component v-else :is="layout"/>
    <modal-install-app  :opened="showInstallModal"
                        @accept="acceptInstall"
                        @decline="declineInstall"
    />
    <modal-update-app  :opened="showUpdateModal"
                        @accept="applyUpdate"
    />
</template>
<script setup>
import {computed, watch} from "vue";
import {useRouter} from "vue-router";
import {useOnline, useSessionStorage} from '@vueuse/core'
import LayoutEmpty from "@/layout/LayoutEmpty.vue";
import LayoutNoHeader from "@/layout/LayoutNoHeader.vue";
import Layout from "@/layout/Layout.vue";
import ModalInstallApp from "@/components/ModalConfirmation/ModalInstallApp.vue";
import mixpanel from "mixpanel-browser";
import {useUserInfo} from "@/composables/useUserInfo.js";
import {DateAdapter} from "@/modern/core/index.ts";
import {usePwaInstall} from "@/modern/composables/usePwaInstall.ts";
import { usePwaUpdate } from '@/modern/composables/usePwaUpdate'
import ModalUpdateApp from "@/components/ModalConfirmation/ModalUpdateApp.vue";

const defaultLayout = "default";
const {replace, currentRoute} = useRouter();
const {userInfoLoaded} = useUserInfo()
const loading = useSessionStorage('showLoading',true, {mergeDefaults: (storageValue) => !userInfoLoaded.value ? true : storageValue});
const isOnline = useOnline()

const dateAdapter = DateAdapter.instance()

const {
    isInstallModalOpen,
    acceptInstall,
    declineInstall
} = usePwaInstall(dateAdapter, {
    onAppInstalled() {
        if (mixpanel.__loaded) {
            mixpanel.track('app_de_encontros_instalado', {
                origem: 'App de Encontros'
            })
        }
    }
})

const {
    isUpdateAvailable,
    applyUpdate
} = usePwaUpdate({
    onUpdateDetected() {
        if (mixpanel.__loaded) {
            mixpanel.track('pwa_update_available')
        }
    },
    onUpdateApplied() {
        if (mixpanel.__loaded) {
            mixpanel.track('pwa_update_applied')
        }
    }
}, {
    enablePolling: true
})

const layout = computed(
    () => {
        const layout = currentRoute.value.meta.layout || defaultLayout
        switch (layout) {
            case 'no-header':
                return LayoutNoHeader
            case 'empty':
                return LayoutEmpty
            default:
                return Layout
        }
    }
)

const showInstallModal = computed(
    () => isInstallModalOpen.value && !isUpdateAvailable.value && !loading.value
)

const showUpdateModal = computed(
    () => isUpdateAvailable.value && !loading.value
)

const onLoaded = () => {
    loading.value = false
}

watch(
    currentRoute,
    (value, oldValue) => {
        if (value.name !== oldValue.name) {
            document.body.style.overflow = 'auto'
        }
    }
)

watch(
    isOnline,
    (value) => {
        if (!value) {
            replace({
                name: 'offline'
            })
        }
    },
    {
        immediate: true
    }
)

</script>
